<template>
  <div class="area-item-warp wh-flex-start">
    <el-image
      style="width: 50px; height: 50px"
      :src="item.src"
      fit="contain"
    />
    <div class="item-txt">
      <div class="title">
        <span class="title-txt">{{ item.name }}</span>
        <span v-if="item.remarks" class="remarks">({{ item.remarks }})</span>
      </div>
      <div class="item-num">
        <span class="num-txt">{{ item.num }}</span>
        <span class="unit">{{ item.unit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AreaItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
  .item-txt{
    margin-left: 10px;
    width: 120px;
    .title-txt{
      font-size: 20px;
      color: #0EFCFF;
    }
    .remarks{
      font-size: 20px;
      color: #FFFFFF;
    }
    .item-num{
      margin-top: 6px;
    }
    .num-txt{
      font-size: 24px;
      color: #fdca3a;
    }
    .unit{
      font-size: 14px;
      color: #FFFFFF;
      margin-left: 6px;
    }
  }
</style>
